export const mainNavBorderColors = {
	black: 'border-black',
	elanco_blue: 'border-elanco-blue',
	pet_green: 'border-pet-green',
	vet_purple: 'border-vet-purple',
	white: 'border-white',
}

export type MainNavBorderColor = keyof typeof mainNavBorderColors
